import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import BillingEdit from '../Components/BillingAddressEdit/BillingEdit';
const BillingEditadd = () => {
    const routePath = useLocation();
    const onTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        onTop()
    }, [routePath]);
    return (
        <div>
            <BillingEdit />
        </div>
    )

}

export default BillingEditadd